import { css } from "@emotion/css";

export default function CloseGame() {
	const closeGame = () => {
		window.location.reload();
	};

	return (
		<div className={styles.wrap}>
			<p>Hệ thống bị ngắt kết nối. Vui lòng tải lại trang.</p>
			<button type="button" onClick={closeGame}>
				Tải lại
			</button>
		</div>
	);
}

const styles = {
	wrap: css`
		background: #fff;
		padding: 12px;
		text-align: center;
		border-radius: 12px;
		p {
			font-size: 16px;
			margin-bottom: 24px;
			margin-top: 12px;
			color: #000;
		}
		button {
			padding: 12px 16px;
			width: 200px;
			background: #2196f3;
			border-radius: 8px;
			color: #fff;
			text-transform: uppercase;
			cursor: pointer;
		}
	`,
};
